"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDateTimeConfig = void 0;
var DeviceCharacteristic_1 = require("../../../common/DeviceCharacteristic");
// eslint-disable-next-line import/prefer-default-export
var setDateTimeConfig = function (device, value, withResponse) {
    console.log('Setting device Time to: ', new Date(value * 1000));
    var buffer = new ArrayBuffer(4);
    var values = new DataView(buffer);
    values.setUint32(0, value);
    return device.writeCharacteristicValues(device.profile.VAPING.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.VapingCharacteristics.TIME; }).uuid, values.buffer, withResponse);
};
exports.setDateTimeConfig = setDateTimeConfig;
